import { render, staticRenderFns } from "./coordinates.vue?vue&type=template&id=4296f53c&"
import script from "./coordinates.vue?vue&type=script&lang=ts&"
export * from "./coordinates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4296f53c')) {
      api.createRecord('4296f53c', component.options)
    } else {
      api.reload('4296f53c', component.options)
    }
    module.hot.accept("./coordinates.vue?vue&type=template&id=4296f53c&", function () {
      api.rerender('4296f53c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/coordinates/coordinates.vue"
export default component.exports